import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';

type Props = {
    onComplete?: () => void
}

const Task102: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-102');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-102">
        <h2>zadanie 2</h2>
        <h3>{task?.title}</h3>
        <div className="decor-1">
            <p>
                W bibliotekach można znaleźć wiele poradników dotyczących najróżniejszych tematów. Przykładowo, w książce autorstwa Hal’a Elrod’a pt.: “Fenomen poranka” możemy poznać niezawodną (według autora) metodę wstawania w 5-ciu krokach.
            </p>
            <p className="instruction">
                <strong>Zadanie:</strong> Stwórzcie wspólnie własną listę zdrowych nawyków, ale dotyczących czytania!
            </p>
        </div>

        <QuestionBox>
            <p>
                Sprawdźcie, ile w Waszej bibliotece jest poradników.<br /> Może któryś Was zainspiruje do zmiany nawyków?
            </p>
        </QuestionBox>
    </div>
}

export default Task102;
